import { render, staticRenderFns } from "./pictures-with-label-block.vue?vue&type=template&id=6201fe68&scoped=true"
import script from "./pictures-with-label-block.vue?vue&type=script&lang=js"
export * from "./pictures-with-label-block.vue?vue&type=script&lang=js"
import style0 from "./pictures-with-label-block.vue?vue&type=style&index=0&id=6201fe68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6201fe68",
  null
  
)

export default component.exports